import React from 'react';
import { useLanguage } from '@/components/ui/LanguageContext';
import { motion } from 'framer-motion';
import { FileText } from 'lucide-react';

export default function Terms() {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-black text-white pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 rounded-xl bg-indigo-500/20">
              <FileText className="w-6 h-6 text-indigo-400" />
            </div>
            <h1 className="text-3xl font-bold">
              {language === 'ja' ? '利用規約' : 'Terms of Service'}
            </h1>
          </div>

          <div className="prose prose-invert prose-zinc max-w-none">
            <p className="text-zinc-400 mb-8">
              {language === 'ja' ? '最終更新日: 2024年1月1日' : 'Last updated: January 1, 2024'}
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '第1条（適用）' : 'Article 1 (Application)'}
              </h2>
              <p className="text-zinc-300 leading-relaxed">
                {language === 'ja' 
                  ? '本規約は、本サービスの利用に関する条件を定めるものです。登録ユーザーは、本規約に同意したものとみなします。'
                  : 'These Terms govern your use of our Service. By registering, you agree to these Terms.'}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '第2条（利用登録）' : 'Article 2 (Registration)'}
              </h2>
              <p className="text-zinc-300 leading-relaxed">
                {language === 'ja'
                  ? '利用登録は、Discord認証を通じて行われます。虚偽の情報を登録した場合、利用を停止することがあります。'
                  : 'Registration is done through Discord authentication. We may suspend accounts that register with false information.'}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '第3条（料金および支払い）' : 'Article 3 (Fees and Payment)'}
              </h2>
              <p className="text-zinc-300 leading-relaxed">
                {language === 'ja'
                  ? '有料プランの料金は、サービス内で明示された金額とします。支払いはクレジットカードにより行われます。'
                  : 'Fees for paid plans are as displayed in the Service. Payment is made by credit card.'}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '第4条（禁止事項）' : 'Article 4 (Prohibited Activities)'}
              </h2>
              <ul className="list-disc list-inside text-zinc-300 space-y-2">
                <li>{language === 'ja' ? '法令または公序良俗に違反する行為' : 'Violating laws or public order'}</li>
                <li>{language === 'ja' ? 'コンテンツの無断転載・再配布' : 'Unauthorized redistribution of content'}</li>
                <li>{language === 'ja' ? 'サービスの運営を妨害する行為' : 'Interfering with service operations'}</li>
                <li>{language === 'ja' ? '他のユーザーへの迷惑行為' : 'Harassing other users'}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '第5条（免責事項）' : 'Article 5 (Disclaimer)'}
              </h2>
              <p className="text-zinc-300 leading-relaxed">
                {language === 'ja'
                  ? '当社は、本サービスに起因してユーザーに生じた損害について、故意または重過失がある場合を除き、一切の責任を負いません。'
                  : 'We are not liable for damages arising from the Service, except in cases of intentional misconduct or gross negligence.'}
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}